export default "__VITE_ASSET__B6apnxq0__"